import { Illustration } from '../Illustration/Illustration';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const Logo = props => /*#__PURE__*/_jsx(Illustration, Object.assign({}, props, {
  [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'Logo'
}));
Logo.displayName = 'Logo';